<template>
    <div class="icon-list-container">
        <div class="icons-list">
            <div v-for="(item, index) in items" :key="index" class="icon-item">
                <div class="icon-circle">
                    <component style="color: #117ACB;" :is="item.icon"></component>
                </div>
                <div class="text-content">
                    <span class="number">{{ item.number }}</span>
                    <span class="text">{{ item.text }}</span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const FdsIcon = {
    name: 'FdsIcon',
    template: `
       <svg width="27" height="18" viewBox="0 0 27 18" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M21.375 0H5.625C2.51888 0 0 2.51775 0 5.625V12.375C0 15.4811 2.51888 18 5.625 18H21.375C24.4766 18 27 15.4766 27 12.375V5.625C27 2.52338 24.4766 0 21.375 0ZM9.135 13.5C8.76825 13.5 8.44987 13.2469 8.36775 12.8891L8.06962 11.5875H5.3595L5.05125 12.8936C4.96687 13.2491 4.65075 13.5 4.28512 13.5C3.77775 13.5 3.40313 13.0264 3.519 12.5325L5.10862 5.79038C5.33475 4.81613 6.38775 4.20863 7.42163 4.64175C7.9155 4.84875 8.24738 5.3235 8.36888 5.8455L9.90225 12.537C10.0148 13.0297 9.64125 13.5 9.135 13.5ZM24.75 12.375C24.75 14.2358 23.2358 15.75 21.375 15.75H13.5V2.25H21.375C23.2358 2.25 24.75 3.76425 24.75 5.625V12.375ZM23.0625 6.318V6.34163C23.0625 6.72412 22.752 7.03463 22.3695 7.03463H22.014C21.8779 8.469 21.3199 10.107 20.2061 11.3839C20.8159 11.754 21.5471 12.0184 22.4381 12.1028C22.7925 12.1365 23.0625 12.4358 23.0625 12.7924V12.816C23.0625 13.2277 22.707 13.545 22.2975 13.5056C21.0184 13.383 19.9811 12.9555 19.1385 12.3559C18.2914 12.9611 17.2418 13.3852 15.9525 13.5056C15.543 13.5439 15.1886 13.2266 15.1886 12.8149V12.7913C15.1886 12.4301 15.4676 12.1342 15.8276 12.1005C16.7141 12.0161 17.4454 11.7551 18.0518 11.3861C17.6794 10.9598 17.3689 10.4929 17.1146 10.0057C16.875 9.54675 17.2148 8.99775 17.7323 8.99775H17.7435C17.9978 8.99775 18.2351 9.135 18.3521 9.36C18.5602 9.756 18.8201 10.1374 19.1318 10.4872C20.052 9.45225 20.4727 8.11575 20.5976 7.03238H15.8827C15.5002 7.03238 15.1897 6.72188 15.1897 6.33938V6.31575C15.1897 5.93325 15.5002 5.62275 15.8827 5.62275H18.4219V5.19075C18.4219 4.80825 18.7324 4.49775 19.1149 4.49775H19.1385C19.521 4.49775 19.8315 4.80825 19.8315 5.19075V5.62275H22.3706C22.7531 5.62275 23.0636 5.93325 23.0636 6.31575L23.0625 6.318ZM6.82312 6.14588L7.7085 10.0125H5.73187L6.64425 6.14588C6.65438 6.10425 6.69038 6.075 6.73313 6.075C6.77588 6.075 6.81413 6.10425 6.82312 6.14588Z" fill="#117ACB"/>
</svg>
`
}

const MsdsIcon = {
    name: 'MsdsIcon',
    template: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M18 12C14.686 12 12 14.686 12 18C12 21.314 14.686 24 18 24C21.314 24 24 21.314 24 18C24 14.686 21.314 12 18 12ZM21.192 18.202L18.979 20.326C18.527 20.772 17.927 20.997 17.326 20.997C16.725 20.997 16.123 20.772 15.663 20.323L14.531 19.214C14.136 18.827 14.131 18.194 14.517 17.8C14.903 17.404 15.536 17.399 15.931 17.786L17.062 18.894C17.206 19.036 17.441 19.033 17.584 18.892L19.807 16.758C20.204 16.376 20.838 16.387 21.221 16.787C21.603 17.185 21.59 17.819 21.192 18.202ZM10 18C10 15.61 11.048 13.466 12.709 12H5C4.447 12 4 11.553 4 11C4 10.447 4.447 10 5 10H13C13.553 10 14 10.447 14 11C14 11.024 13.999 11.048 13.997 11.072C15.174 10.39 16.541 10 18 10V5C18 2.243 15.757 0 13 0H5C2.243 0 0 2.243 0 5V19C0 21.757 2.243 24 5 24H12.709C11.048 22.534 10 20.39 10 18ZM5 5H13C13.553 5 14 5.447 14 6C14 6.553 13.553 7 13 7H5C4.447 7 4 6.553 4 6C4 5.447 4.447 5 5 5ZM7 17H5C4.447 17 4 16.553 4 16C4 15.447 4.447 15 5 15H7C7.553 15 8 15.447 8 16C8 16.553 7.553 17 7 17Z" fill="#117ACB"/>
</svg>
 `
}

const TanquesIcon = {
    name: 'TanquesIcon',
    template: `
      <svg width="21" height="25" viewBox="0 0 21 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12.6 17.7083H0V12.5H12.6V17.7083ZM15.75 5.20833H5.25C2.35515 5.20833 0 7.54479 0 10.4167H14.7V19.7917H0V21.875C0 23.5979 1.4133 25 3.15 25H17.85C19.5867 25 21 23.5979 21 21.875V10.4167C21 7.54479 18.6448 5.20833 15.75 5.20833ZM5.25 3.125H15.75C16.4797 3.125 17.1843 3.23125 17.85 3.42917V0H3.15V3.42917C3.8157 3.23229 4.52025 3.125 5.25 3.125Z" fill="#117ACB"/>
</svg>
`
}

const InstalacionesIcon = {
    name: 'InstalacionesIcon',
    template: `
  <svg width="25" height="23" viewBox="0 0 25 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M23.3219 12.0798C22.2396 11.0841 20.801 10.5359 19.2708 10.5359C17.7406 10.5359 16.3021 11.0841 15.2198 12.0788C14.1375 13.0745 13.5417 14.398 13.5417 15.8067C13.5417 17.2155 14.1417 18.5428 15.2594 19.5682L19.2708 22.9933L23.3219 19.5347C24.4042 18.539 25 17.2155 25 15.8067C25 14.398 24.4042 13.0745 23.3219 12.0798ZM19.2708 17.25C18.4083 17.25 17.7083 16.606 17.7083 15.8125C17.7083 15.019 18.4083 14.375 19.2708 14.375C20.1333 14.375 20.8333 15.019 20.8333 15.8125C20.8333 16.606 20.1333 17.25 19.2708 17.25ZM13.8427 20.9731C12.9573 20.1614 12.3167 19.2203 11.9208 18.2083H9.375V16.2917H11.4844C11.4729 16.1307 11.4583 15.9697 11.4583 15.8067C11.4583 15.3199 11.5115 14.8417 11.6135 14.375H9.375V12.4583H12.3562C12.7188 11.8278 13.1833 11.2422 13.7479 10.7237C14.5854 9.95325 15.5833 9.38783 16.6677 9.03517V2.875C16.6677 1.28992 15.2656 0 13.5427 0H3.125C1.40208 0 0 1.28992 0 2.875V23H16.2167L13.8427 20.9731ZM9.375 4.79167H12.5V6.70833H9.375V4.79167ZM9.375 8.625H12.5V10.5417H9.375V8.625ZM7.29167 18.2083H4.16667V16.2917H7.29167V18.2083ZM7.29167 14.375H4.16667V12.4583H7.29167V14.375ZM7.29167 10.5417H4.16667V8.625H7.29167V10.5417ZM7.29167 6.70833H4.16667V4.79167H7.29167V6.70833Z" fill="#117ACB"/>
</svg>
 `
}

export default {
    name: 'IconList',
    components: {
        FdsIcon,
        MsdsIcon,
        TanquesIcon,
        InstalacionesIcon
    },
    props: {
        items: {
            type: Array,
            required: true
        }
    }
}
</script>

<style scoped>
.icon-list-container {
    font-family: 'Poppins', sans-serif;
}

.icons-list {
    display: flex;
    flex-direction: column;
    gap: 1rem;
}

.icon-item {
    display: flex;
    align-items: center;
    gap: 1rem;
}

.icon-circle {
    width: 50px;
    height: 50px;
    background-color: #ffffff;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}

.text-content {
    display: flex;
    align-items: center;
    gap: 0.5rem;
}

.number {
    font-size: 20px;
    font-weight: 700;
    color: #1B212E;
}

.text {
    font-size: 20px;
    color: #1B212E;
}

@media (max-width: 576px) {
    .icon-circle {
        width: 36px;
        height: 36px;
    }

    .number,
    .text {
        font-size: 13px;
    }
}
</style>
